import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, Input, Output, signal, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators, FormBuilder, FormGroup, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { EditorModule } from '@tinymce/tinymce-angular';
import { iCatalogos, iEntrada, iEntregables, mEntregables } from '../entrada.interface';
import { Store, select } from '@ngrx/store';
import { Observable, Subject, Subscription, firstValueFrom, map } from 'rxjs';
import { AlertaService } from '../../alerta/alerta.service';
import { AppState } from '../../app.state';
import { LoadingService } from '../../loading/loading.service';
import { selectCatalogos } from '../../states/catalogos/selector';
import { selectEntrada } from '../../states/entrada/selector';
import { EntradaService } from '../entrada.service';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { selectUsuario } from '../../states/usuario/selector';
import { iUsuario } from '../../usuario/usuario.interface';
import { environment } from '../../../environments/environment';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { selectEntregables } from '../../states/entregables/selector';
import { cargaEntregables } from '../../states/entregables/actions';
import { createTimeout, downloadFile, getTimeConsole } from '../../utils';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-entregable',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatTabsModule, ReactiveFormsModule, MatInputModule, 
    MatFormFieldModule, FormsModule, MatRadioModule, MatDatepickerModule, MatSelectModule, MatAutocompleteModule,
    MatChipsModule, EditorModule, MatCardModule, CommonModule, MatProgressBarModule],
  templateUrl: './add-edit-entregable.component.html',
  styleUrl: './add-edit-entregable.component.css'
})
export class AddEditEntregableComponent {
  @ViewChild('inputFile') inputFile!: ElementRef;
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private alertaService = inject(AlertaService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  private readonly stateCatalogo: any = this.store.pipe(select(selectCatalogos));
  private readonly stateEntregables: any = this.store.pipe(select(selectEntregables));
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private subscriptions = new Subscription();
  private banResponsablesInicial = false;

  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();

  public oEntrada: iEntrada;
  public oUsuario: iUsuario;
  public oCatalogos: iCatalogos;
  public catEntregable:any = [];
  public catUsuarios:any = [];
  public formEntregable!: FormGroup;
  public listaEntregables: iEntregables[] = [];
  public processEntregables: any = [];
  public estadosEntregable: any;
  public banResponsables: boolean = false;
  public deshabilitado: boolean = false;
  public idGasProceso: string = '';

  //public edicion = true;
  public desabilitado = true;
  public bitacora = false;
  public invalidEntregables = false;

  constructor() {
    this.loadingService.show();

    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oUsuario = this.stateUsuario.state().usuario;
    this.oCatalogos = this.stateCatalogo.state().catalogos;
    this.catEntregable = this.oCatalogos.catEntregable;
    this.catUsuarios = this.oCatalogos.catUsuarios;
    this.estadosEntregable = this.entradaService.obtenerCatalogoEstadoEntregales();
    
    this.formEntregable = this.formBuilder.group({
      tipo: ['', [Validators.required]],
      tipo_descripcion: ['', [Validators.required]]
    });

    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    this.formEntregable.get('tipo')?.valueChanges.subscribe(value => {
      this.businessRules('tipo', value);
    });
    ////////////////////////////////////////////////////////////////////////////////////

    ///////////// BANDERA SOLO PARA GUARDAR CUANDO ES EL PRIMER ENTREGABLE /////////////
    this.banResponsablesInicial = (this.oEntrada.analista == '' && this.oEntrada.supervisor == '' && this.oEntrada.coordinador == '')? true : false;
    ////////////////////////////////////////////////////////////////////////////////////

    this.loadingService.hide();
  }

  ngOnInit () {
    this.idEntrada = this.active.snapshot.params['id'];
    this.idTema = this.active.snapshot.params['tema'];

    this.subscriptions.add(
      this.store.select(selectEntrada).subscribe((oEntrada) => {
        this.banResponsables = (oEntrada.analista != '' && oEntrada.supervisor != '' && oEntrada.coordinador != '')? true : false;
        this.oEntrada = structuredClone(oEntrada);
      })
    );

    this.subscriptions.add(
      this.listenToFather.subscribe((oData: any) => {
        if(oData.accion == 'disabled') {
          this.deshabilitado = oData.deshabilitado;
          if(oData.deshabilitado) {
            //this.formEntregable.disable({emitEvent: false});
          } else {
            this.formEntregable.enable({emitEvent: false});
          }
        }
      })
    );

    this.cargaEntregables();
    
    if(this.idEntrada != 'add') {
      this.deshabilitado = true;
      //this.formEntregable.disable({emitEvent: false});
    }
  }

  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }

  async cargaEntregables() {
    const result:any = await firstValueFrom(this.entradaService.obtenerEntregables(this.idEntrada));
    
    this.listaEntregables = result.map((item: any) => {
      
      if(this.oUsuario.uid == item.analista || this.oUsuario.uid == item.supervisor || this.oUsuario.uid == item.coordinador || this.oUsuario.uid == "vGrKmfPcCmZTx2Uov2wZN1HqDWl1") 
        this.bitacora = true;

      if (this.oUsuario.uid == item.analista && item.url == undefined && item.tipo != "adjuntar") {
        item.nuevo = true;
        item.used = false;
        item.idGas = (item.idGas == undefined)? null: item.idGas;
      } else if (this.oUsuario.uid != item.analista && item.url == undefined && item.tipo != "adjuntar") {
        item.url = null;
        item.title = null;
        item.idGas = null;
        item.nuevo = true;
      } else if (item.url == undefined && item.tipo == "adjuntar") {
        item.url = null;
        item.title = null;
        item.idGas = null;
      }

      if (item.archivos != undefined) {
        item.files = structuredClone(item.archivos);
        this.entradaService.obtenerArchivoEntregable(item.id, item.archivos).then(function(oArchivos: any) {
            item.archivos = oArchivos;
        });
      } else {
        item.archivos = [];
        item.files = [];
      }

      return item;
    });

    //this.store.dispatch(cargaEntregables({ oEntregables: structuredClone(this.listaEntregables)}));
    this.validaEntregable();
  }

  businessRules (type:string, value:any): void {
    if(type == 'tipo') {
      const entregable:any = value != 'otro'? this.catEntregable.filter((item:any) => item.id == value)[0]:{ descripcion: ''};
      this.formEntregable.get('tipo_descripcion')?.setValue(entregable?.descripcion);
    }
  }

  guardaEntregable() {
    const oData = this.formEntregable.value;

    let itemEntregable = {
      tipo: oData.tipo,
      tipo_descripcion: oData.tipo_descripcion,
      estatus: 1,
      estatus_descripcion: this.estadosEntregable.estados[1],
      comentarios: '',
      archivos: [],
      files: [],
      used: false,
      nuevo: true,
      edicion: true,
      prioridad: 2,
      url: null,
      title: null,
      idGas: null,
      edicion_usuario: false,
      motivo_cancelacion: ''
    }

    this.listaEntregables.push(itemEntregable);
    this.formEntregable.get('tipo')?.setValue('');
    this.formEntregable.get('tipo_descripcion')?.setValue('');
    this.validaEntregable();
  }

  selectFile(index:number, item: iEntregables, event: any): void {
    const files = event.target.files;

    for(let i = 0; i < files.length; i++) {
      const file = files[i];
      this.agregarArchivos(file, item);
    }

    this.inputFile.nativeElement.value = '';
    this.validaEntregable();
  }

  agregarArchivos(file: any, item: iEntregables) {
    let repetido = false;
    for(const i in item.archivos) {
      if(item.archivos[i].name == file.name) {
        repetido = true;
      }
    }

    if(repetido == false) {
      item.archivos.push({name: file.name, metadata: file.type});
      item.files.push({name: file.name, metadata: file.type, file: file});
    } else {
      this.alertaService.open("Error", "El archivo ya se encuentra seleccionado.");
    }
  }

  /* agregarArchivos(index:number, item: iEntregables, event: any) {
    const file = event.target.files.item(0);
    this.inputFile.nativeElement.value = '';

    let repetido = false;
    for(const i in item.archivos) {
      if(item.archivos[i].name == file.name) {
        repetido = true;
      }
    }

    if(repetido == false) {
      item.archivos.push({name: file.name, metadata: file.type});
      item.files.push({name: file.name, metadata: file.type, file: file});
      this.validaEntregable();
    } else {
      this.alertaService.open("Error", "El archivo ya se encuentra seleccionado.");
    }
  } */

  eliminarArchivos (index: number, item: iEntregables) {
    item.archivos.splice(index, 1);
    item.files.splice(index,1);
    this.validaEntregable();
  }

  abrirDocumento(item:iEntregables) {
    window.open(item.url!, "_blank");
  }

  generarDocumento() {
    var w = 625, h = 525;
    var left = (screen.width/2)-(w/2);
    var top = (screen.height/2)-(h/2);
    window.open(environment.entregables.gas, "Generador de Documentos VPE", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
  }

  async obtenerDocumento(event: any, item:iEntregables) {
    const idGas = event.target.value;
    const valid = event.target.validity.valid;

    if(valid) {
      this.loadingService.show();
      const uid = this.oUsuario.uid;
      let data: any = null;
      try {
        data = await firstValueFrom(this.entradaService.getDocumento(idGas));  
      } catch (error) {
        data = null;
      }

      if(data && data.used == false) {
        item.url = data.url;
        item.title = data.title;
        item.idGas = idGas;
        item.used = true;

        await this.entradaService.guardarDocumentoUsed(idGas);

        //GUARDADO AUTOMATICO
        if(this.idEntrada == 'add' || this.banResponsablesInicial) { //if(this.idEntrada == 'add') {
          this.validaEntregable();
          await createTimeout(1000);
          console.log("ENTRA A GUARDAR AUTOMATICO ENTREGABLE");
          this.sendToFather.next({'accion':'GUARDADO AUTOMATICO'});
          return;
        } else {

          //VALIDAR QUE EL ANALISTA SEA EL MISMO QUE LO GENERO
          if(uid != this.oEntrada.analista) {
            this.alertaService.open("Documento", "Esta sección está deshabilitada ya que tú no has sido asignado para generar el entregable");
          }

          if(this.idEntrada != 'add' && this.banResponsables) {
              if(item.id) {
                const result: any =  await this.entradaService.guardaEntregables(this.idEntrada, this.oEntrada, [item], this.oUsuario);
                if(Object.hasOwn(result, 'idEntrada')) {
                  item.nuevo = false;
                } else {
                  console.log(result);
                  this.alertaService.open("Error", "Ups problemas al guardar el entregable");
                }
              } else {
                const result: any =  await this.entradaService.guardaEntregable(this.idEntrada, this.oEntrada, item, this.oUsuario);
                if(Object.hasOwn(result, 'idEntregable')) {
                  item.id = result.idEntregable;
                  item.nuevo = false;
                  if(this.oEntrada.analista != '') {
                    item.analista = this.oEntrada.analista;
                  }
                } else {
                  console.log(result);
                  this.alertaService.open("Error", "Ups problemas al guardar el entregable");
                }
              }
          }
        }

      } else if(data) {
        item.idGas = null;
        this.alertaService.open("Documento Error", "El ID del documento ingresado ya fue utilizado");
        event.target.value = '';
      } else {
        item.idGas = null;
        this.alertaService.open("Documento Error", "El ID del documento ingresado no existe.");
        event.target.value = '';
      }

      this.validaEntregable();
      this.loadingService.hide();
    }
  }

  /*async createTimeout(ms: number): Promise<any> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve('Timeout Exceeded');
      }, ms);
    });
  }*/

  async accionEntregable (accion: number, index: number, item: iEntregables) {
    this.loadingService.show();
    let guardado = false;
    let cambioEstatus = true;
    console.log("SHOW", getTimeConsole());
  
    if(accion == 0 && item.nuevo == true) {
      //BORRAMOS
      if(this.idEntrada != 'add' && item.id) {
        await this.entradaService.borrarEntregable(this.idEntrada, item.id);
      }
      this.listaEntregables.splice(index, 1);
      this.loadingService.hide();
    } else if(accion == 1) {
      //ENVIAMOS A SUPERVISOR
      if(accion < item.estatus){
        item.prioridad = 1;
      }
      item.estatus = 1;
      item.estatus_descripcion = this.estadosEntregable.estados[1];
      guardado = true;
    } else if(accion == 2) {
      //ENVIAMOS A SUPERVISOR
      if(accion < item.estatus){
        item.prioridad = 1;
      }
      item.estatus = 2;
      item.estatus_descripcion = this.estadosEntregable.estados[2];
      guardado = true;
    } else if(accion == 3) {
      //ENVIAMOS A COORDINADOR
      if(accion < item.estatus){
        item.prioridad = 1;
      }
      item.estatus = 3;
      item.estatus_descripcion = this.estadosEntregable.estados[3];
      guardado = true;
    } else if(accion == 4) {
      //ENVIAMOS A TERMINADO
      if(accion < item.estatus){
        item.prioridad = 1;
      }
      item.estatus = 4;
      item.estatus_descripcion = this.estadosEntregable.estados[4];
      guardado = true;
    } else if(accion == 5) {
      //ENVIAMOS A EJECUCION
      if(accion < item.estatus){
        item.prioridad = 1;
      }
      item.estatus = 5;
      item.estatus_descripcion = this.estadosEntregable.estados[5];
      guardado = true;
    } else if(accion == 6) {
      //CANCELAMOS
      this.loadingService.hide();
      const dialogRef = this.alertaService.motivoCancelacion({motivo_cancelacion:''});
      dialogRef.afterClosed().subscribe((result:any) => {
        item.accion = null;
        if(result) {
          this.loadingService.show();
          item.estatus = 6;
          item.estatus_descripcion = this.estadosEntregable.estados[6];
          item.motivo_cancelacion = result.motivo_cancelacion.trim();
          item.edicion = false;
          item.usuario_cancelacion = this.oUsuario.nombre;
          
          this.entradaService.actualizaEntregables(this.idEntrada, this.oEntrada, [item], this.oUsuario, cambioEstatus).then(
            (response) => {
              this.loadingService.hide();
            }, (error) => {
              this.loadingService.hide();
              this.alertaService.open("Error", "Ups problemas al guardar el entregable");
          });
          this.validaEntregable();
        }
      });
    } else if(accion == 9) {
      //SOLO GUARDAMOS
      guardado = true;
      cambioEstatus = false;
    } else if(accion == 10) {

      if(item.tipo != "adjuntar" && !item.url) {
        this.alertaService.open("Error", "Es necesario generar el documento antes.");
        this.loadingService.hide();
        return;
      }

      if(item.tipo == "adjuntar" &&  item.archivos.length == 0) {
        this.alertaService.open("Error", "El entregable debe tener por lo menos un archivo adjunto");
        this.loadingService.hide();
        return;
      }

      //GUARDAR ENTREGABLE
      if(item.tipo != "adjuntar" || (item.tipo == "adjuntar" && item.archivos.length > 0)) {
          
        if(this.idEntrada != 'add' && this.banResponsables) {
            if(item.id) {
              try {
                const result: any = await this.entradaService.guardaEntregables(this.idEntrada, this.oEntrada, [item], this.oUsuario);
                if(Object.hasOwn(result, 'idEntrada')) {
                  item.edicion = false;
                  item.edicion_usuario = false;
                  item.nuevo = false;
                  this.loadingService.hide();
                } else {
                  console.log(result);
                  this.alertaService.open("Error", "Ups problemas al guardar el entregable 010");
                }
                this.showUploadFilesEntregables();
              } catch (error: any) {
                const mensaje = error.message? error.message: error.toString();
                this.alertaService.open("Error", mensaje);
              }
            } else {
              if(item.tipo == "adjuntar" || item.url != null) {
                try {
                  const result: any = await this.entradaService.guardaEntregable(this.idEntrada, this.oEntrada, item, this.oUsuario);
                  if(Object.hasOwn(result, 'idEntrada')) {
                    item.edicion = false;
                    item.edicion_usuario = false;
                    item.nuevo = false;
                    item.id = result.idEntregable;
                    this.loadingService.hide();
                  } else {
                    console.log(result);
                    this.alertaService.open("Error", "Ups problemas al guardar el entregable 011");
                  }
                  this.showUploadFilesEntregables();
                } catch (error: any) {
                  const mensaje = error.message? error.message: error.toString();
                  this.alertaService.open("Error", mensaje);
                }
              } else {
                this.alertaService.open("Error", "Es necesario generar el documento antes.");
              }
            }
        } else {
            item.edicion = false;
            item.edicion_usuario = false;
            this.alertaService.open("Error", "Es necesario guardar entrada con sus responsables");
        }

      } else {
        this.alertaService.open("Error", "El entregable debe tener por lo menos un archivo adjunto");
      }
    }

    if(guardado == true) {
      //let timeout = item.accion == 5? 3000 : 0;
      item.accion = null;
      
      //console.log("MIDDLE 1", getTimeConsole());
      //await createTimeout(timeout);
      //console.log("MIDDLE 2", getTimeConsole());

      //setTimeout(async () => {
        //this.loadingService.show();
        const result: any = await this.entradaService.actualizaEntregables(this.idEntrada, this.oEntrada, [item], this.oUsuario,  cambioEstatus);
        const resultTask = await this.showUploadFilesEntregables();
        if(Object.hasOwn(result, 'idEntrada')) {
          if(item.archivos.length > 0 && item.id) {
            item.files = structuredClone(item.archivos);
            this.entradaService.obtenerArchivoEntregable(item.id, item.archivos).then(function(oArchivos: any) {
              item.archivos = oArchivos;
            });
          }
        } else {
          this.alertaService.open("Error", "Ups problemas al guardar el entregable");
        }

        //this.validaEntregable();
        //this.showUploadFilesEntregables();
        //this.loadingService.hide();
      //}, timeout);
    }

    console.log("HIDE", getTimeConsole());
    this.validaEntregable();
    this.loadingService.hide();
  }

  ///////////////////////////////////////////////////////////////////////////
  validaEntregable() {
    let userLogged = this.oUsuario.uid;
    
    let userRolSupervisor = this.catUsuarios.filter((item: any) => (item.rol == 2 && item.id == userLogged)).length > 0 ? true : false;
    let userRolCoordinador = this.catUsuarios.filter((item: any) => (item.rol == 3 && item.id == userLogged)).length > 0 ? true : false;

    this.invalidEntregables = false;

    for(let i in this.listaEntregables) {
      var item = this.listaEntregables[i];
      item.edicion = false;
      item.edicion_usuario = false;

      //VALIDACION CUANDO ESTAN GUARDADOS
      if(item.estatus == 1 && (item.analista == userLogged || this.oUsuario.rol == 1)) {
          if(item.url != undefined && item.url != null && item.analista != userLogged) {
              item.edicion = false;
          } else {
              item.edicion = true;
          }
      }
      
      if((item.estatus == 2 || item.estatus == 4) && userRolSupervisor == true) {
          item.edicion = true;
          item.edicion_usuario = true;
      }
      if((item.estatus == 3 || item.estatus == 4) && userRolCoordinador == true) {
          item.edicion = true;
          item.edicion_usuario = true;
      }

      //VALIDACION CUANDO SON NUEVOS
      if (item.nuevo == true) {
          if(this.oEntrada.analista == userLogged || this.oEntrada.supervisor == userLogged || this.oEntrada.coordinador == userLogged) {
              item.edicion = true;
          } else {
              item.edicion = false;
          }
      }

      //VALIDACION PARA IMPRIMIR SIEMPRE
      if(item.analista == userLogged || item.supervisor == userLogged || item.coordinador == userLogged) {
          item.edicion_usuario = true;
      } else if(this.oEntrada.analista == userLogged || this.oEntrada.supervisor == userLogged || this.oEntrada.coordinador == userLogged) {
          item.edicion_usuario = true;
      }

      //SI UN ENTREGABLE ES TIPO ADJUNTAR, SIEMPRE DEBE TENER UN DOCUMENTO
      if(item.tipo == "adjuntar" && item.archivos.length == 0) {
        this.invalidEntregables = (item.edicion === true)? true : false;
      } else if(item.tipo != "adjuntar" && item.nuevo == true && item.used == false && this.oEntrada.analista == userLogged) {
        //MIENTRAS EXISTA UN ENTREGABLE SIN DOCUMENTO Y EL USUARIO SEA ANALISTA, NO SE PUEDE GUARDAR LA ENTRADA
        this.invalidEntregables = true;
      }
    }

    this.actualizaRedux();
    this.sendToFather.next({formEntregables: this.invalidEntregables?'INVALID':'VALID'});
  }

  actualizaRedux () {
    this.store.dispatch(cargaEntregables({oEntregables: structuredClone(this.listaEntregables)}));
  }

  bitacoraEntregables () {
    this.loadingService.show();
    this.subscriptions.add(
      this.entradaService.obtenerBitacora({
        "id": this.idEntrada,
        "asunto": this.oEntrada.asunto,
        "fecha": moment(this.oEntrada.fechaInicio).format('DD/MM/YYYY')
      }).subscribe({
        next: (dataFile: any) => {
          if (!dataFile.error) {
            downloadFile(dataFile, 'bitacora');
          } else {
            this.alertaService.open("Error 040", dataFile.message);
          }
        },
        error: (error) => {
          this.alertaService.open('Error', 'Ups tenemos problemas al descargar la bitacora');
        },
        complete: () => {
          this.loadingService.hide();
        },
      })
    );
  }

  async showUploadFilesEntregables() {
    const taskEntregables: any[] = this.entradaService.getTaskUploadingEntregables();
    const uploadPromise: any[] = [];
   
    for(let i in taskEntregables) {
      let uploadTask = taskEntregables[i];
      uploadPromise.push(uploadTask._promise);
      /*uploadTask.on('state_changed', (snapshot: any) => {
        let progress = Math.ceil((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        this.processEntregables[i] = {
          name: snapshot.ref.name,
          progress: progress,
          status: "Subiendo"
        };
        console.log('Upload is ' +  this.processEntregables[i].name + ': ' +  this.processEntregables[i].progress + '% done');
      }, (error: any) => {
        console.log(error);
        this.processEntregables[i].status = 'Error al subir el archivo:' + error.code;
      }, () => {
        this.processEntregables[i].status = "Subida Completa";
      });*/
    } 

    const result = await Promise.all(uploadPromise);
    console.log(result);
    return result;
  }

  ocultaSeccion (item: any) {
    if (item.tipo == 'adjuntar')
      return true;

    if (this.oUsuario.rol != 1 && item.url == null)
      return true;

    return false;
  }

  validaChangeDocumento(event: any, item:iEntregables) {
    const idGas = event.target.value;
    const valid = event.target.validity.valid;
    console.log(idGas, this.idGasProceso);

    if(valid && this.idGasProceso != idGas) {
      this.idGasProceso = idGas
      this.obtenerDocumento(event, item);
      event.stopPropagation();
    } else {
      this.idGasProceso = idGas
    }
  }
}